import { Type } from '@angular/core';
import { DasboardTileTypes } from 'root/mibp-openapi-gen/models';
import { PromotionForDashboardVm } from 'root/services/mibp-http-api/promotion-http-service.class';

export interface TileItemOptions {
  component: Type<any>;

  /***
   * The resource string for the name of the tile
   */
  tileResourceStringKey: string;

  /***
   * The default sort order of the tile
   */
  sortOrder: number;

  /***
   * Function that must return true if the user has access to see this tile
   */
  accessTestCallback: () => boolean;
  type: DasboardTileTypes;
  tileRedirectLink?: string;
  promotions?: PromotionForDashboardVm[];
  isHeaderApplicable?: boolean;
  isHiddenByUser?: boolean;
}

export class TileItem {

  public component: Type<any>;
  public titleResourceStringKey: string;
  public titleRedirectLink: string;
  public isHiddenByUser: boolean;
  public sortOrder: number;
  public Type: DasboardTileTypes;
  public promotions?: PromotionForDashboardVm[];
  public isHeaderApplicable = true;
  public testUserAccess: () => boolean = () => false;

  constructor(options: TileItemOptions) {
    this.component = options.component;
    this.titleResourceStringKey = options.tileResourceStringKey;
    this.titleRedirectLink = options.tileRedirectLink || '';
    this.isHiddenByUser = !!options.isHiddenByUser;
    this.sortOrder = options.sortOrder;
    this.Type = options.type;
    this.promotions = options.promotions;
    this.isHeaderApplicable = typeof options.isHeaderApplicable !== 'undefined' ? options.isHeaderApplicable : true;
    this.testUserAccess = options.accessTestCallback;
  }

}
